/**
 * Google login Component
 */
/* jshint ignore:start */
(function (itxApp) {
    'use strict';

    /**
     * Google login Component
     * @name GoogleLoginCtrl
     * @type ItxGoogleLoginCmpCtrl
     */
    var ItxGoogleLoginCmp = {
        bindings: {
            onLogin: '&',
            btnClass: '@'
        },
        require: {
            userAccessCtrl: '?^itxUserAccess'
        },
        controller: ItxGoogleLoginCmpCtrl,
        controllerAs: 'googleLoginCtrl',
        templateUrl: [
            '$element',
            '$attrs',
            function ($element, $attrs) {
                return $attrs.template || 'itx-google-login.component.html';
            }
        ]
    };

    ItxGoogleLoginCmpCtrl.$inject = [
        'ItxErrorMessagesFct',
        'ngDialog',
        'ItxHeaderFct',
        'ItxLoaderFct',
        'ItxLoginSvc',
        'ItxTranslateSvc',
        'CmsConfigSvc',
        '$rootScope'
    ];

    function ItxGoogleLoginCmpCtrl(
        ItxErrorMessagesFct,
        ngDialog,
        ItxHeaderFct,
        ItxLoaderFct,
        ItxLoginSvc,
        ItxTranslateSvc,
        CmsConfigSvc,
        $rootScope
    ) {
        var _this = this;

        _this.$onInit = function () {
            _this.showGoogleLogin = false; // false;

            CmsConfigSvc.getProperty('GOOGLE_LOGIN_ENABLED')
                .then(function (isEnabled) {
                    if (isEnabled) {
                        enableButton();
                        init();
                    }
                })
                .catch((error) => {
                    console.error('ItxGoogleLoginCmpCtrl:', error);
                });
        };

        function getGoogleAppId() {
            return new Promise(function (resolve, reject) {
                inditex.onReady(function () {
                    if (_this.showGoogleLogin) {
                        inditex.getXConfigParameter('GOOGLE_APP_ID', function (googleAppId) {
                            if (googleAppId) {
                                _this.googleAppId = googleAppId.value;
                                resolve({ googleAppId: googleAppId.value });
                            }
                        });
                    }
                });
            });
        }

        function getEnableNewValidationGoogleLogin() {
            return new Promise(function (resolve, reject) {
                inditex.onReady(function () {
                    if (_this.showGoogleLogin) {
                        inditex.getXConfigParameter('ENABLE_NEW_VALIDATION_GOOGLE_LOGIN', function (config) {
                            _this.enableNewValidationGoogleLogin = config.value;
                            resolve({ enableNewValidationGoogleLogin: config.value });
                        });
                    }
                });
            });
        }

        function injectScript() {
            return new Promise((resolve, reject) => {
                var js;
                var id = 'google-platform';
                var ref = document.getElementsByTagName('script')[0];

                if (document.getElementById(id)) {
                    reject({ error: 'scriptAlreadyInjected' });
                }

                js = document.createElement('script');
                js.id = id;
                js.async = true;
                js.defer = true;
                js.src = '//accounts.google.com/gsi/client';
                js.onload = () => {
                    resolve(window['google']);
                };

                ref.parentNode.insertBefore(js, ref);
            });
        }

        function enableButton() {
            _this.showGoogleLogin = true;
        }

        function init() {
            getGoogleAppId()
                .then(getEnableNewValidationGoogleLogin())
                .then(injectScript)
                // .then(initializeAuth)
                .then(enableButton)
                .catch((error) => {
                    switch (error) {
                        case 'scriptAlreadyInjected':
                            enableButton();
                            break;
                        default:
                            _this.showGoogleLogin = false;
                            console.error('ItxGoogleLoginCmpCtrl.init:', error);
                    }
                });
        }

        function initV2() {
            enableButton();
        }

        function doSocialLogin(googleUser) {
            var profile = googleUser.getBasicProfile();

            var data = {
                socialToken: googleUser.getAuthResponse().id_token,
                socialId: profile.getId(),
                privacyPolicyAccepted: true,
                email: profile.getEmail(),
                socialType: 'G'
            };

            return ItxLoginSvc.socialLogin(data)
                .then(function (userJSON) {
                    return {
                        googleUser: googleUser,
                        userJSON: userJSON
                    };
                })
                .then(socialLoginSucess)
                .catch(socialLoginFailed);
        }

        function doSocialLoginV2(businessData) {
            var data = {
                socialToken: businessData.code,
                socialType: 'G',
                privacyPolicyAccepted: true
            };

            return ItxLoginSvc.socialLogin(data)
                .then(function (userJSON) {
                    return {
                        googleUser: googleUser,
                        userJSON: userJSON
                    };
                })
                .then(socialLoginSucess)
                .catch(socialLoginFailed);
        }

        function socialLoginSucess(data) {
            inditex.iUserJSON = data.userJSON;
            sessionStorage.setItem('cache-current-user', JSON.stringify(inditex.iUserJSON));
            $rootScope.$broadcast('login:success', data.userJSON);

            ItxHeaderFct.toggleLogin(true);
        }

        function openLinkAccountDialog() {
            ngDialog.open({
                template:
                    '<itx-social-login-link-account-dialog user="ngDialogData.user" on-continue="ngDialogData.onContinue(user,true)" close-dialog="closeThisDialog()"></itx-social-login-link-account-dialog>',
                plain: true,
                className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ',
                showClose: true,
                data: {
                    user: _this.user,
                    onContinue: _this.enableNewValidationGoogleLogin ? _this.doSocialLoginV2 : _this.doSocialLogin
                }
            });
        }

        function openRegisterAccountDialog() {
            ngDialog.open({
                template:
                    '<itx-social-login-register-account-dialog user="ngDialogData.user" on-continue="ngDialogData.onContinue(user,true)" close-dialog="closeThisDialog()"></itx-social-login-register-account-dialog>',
                plain: true,
                className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ',
                showClose: true,
                data: {
                    user: _this.user,
                    onContinue: _this.enableNewValidationGoogleLogin ? _this.doSocialLoginV2 : _this.doSocialLogin
                }
            });
        }

        function socialLoginFailed(error) {
            console.error('ItxGoogleLoginCmpCtrl.socialLoginFailed:', error);

            switch (error.errorKey) {
                // TODO: ¿qué tipos de error se pueden recibir?
                case 'INVALID_SOCIAL_USER_NEED_EMAIL':
                    openRegisterAccountDialog();
                    break;
                case '_APP_PERSON_REGISTER':
                    openRegisterAccountDialog();
                    break;
                case 'INVALID_SOCIAL_USER_NEED_PASSWORD':
                    openLinkAccountDialog();
                    break;
                case 'INVALID_SOCIAL_CREDENTIALS':
                    ItxErrorMessagesFct.dialog(ItxTranslateSvc.translateCms('legacy.ItxSocialLoginPage.googleLoginError'));
                    break;
                default:
                    // Generic error
                    ItxErrorMessagesFct.dialog(error.errorMessage);
                    break;
            }

            throw error;
        }

        function uuid() {
            var d = _.now();
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + _.random(16)) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
            });
        }

        // Public Methods
        /**
         * Funcion para probar login manual. Lanzar URL en un navegador para obtener el code
         */
        // _this.loginV2 = function loginV2() {
        //     getGoogleAppId()
        //         .then(function (businessData) {
        //             var baseUrl = 'https://accounts.google.com';
        //             var redirectUrl = 'https://localhost:6001/es/';
        //             var nonce = uuid();
        //             var state = 'foooBAR'
        //             var url = `${baseUrl}/o/oauth2/v2/auth?response_type=code&client_id=${businessData.googleAppId}&scope=openid%20email&nonce=${nonce}&redirect_uri=${redirectUrl}&state=${state}`;
        //             console.log(url);
        //             //window.location.href = url;
        //         })
        //         .catch(function (error) {
        //             console.error('ItxGoogleLoginCmpCtrl.login:', error);
        //         });
        // }

        _this.authorize = function authorize() {
            // _this.loginV2();
            if (_this.enableNewValidationGoogleLogin) {
                const client = google.accounts.oauth2.initCodeClient({
                    client_id: _this.googleAppId,
                    scope: 'openid email',
                    callback: (googleData) => {
                        doSocialLoginV2(googleData);
                    }
                });
                client.requestCode();
            } else {
                const client = google.accounts.oauth2.initTokenClient({
                    client_id: _this.googleAppId,
                    scope: 'openid email',
                    callback: (googleData) => {
                        doSocialLogin(googleData);
                    }
                });
                client.requestAccessToken();
            }
        };
    }

    /** Public */
    angular.module('itxApp.common').component('itxGoogleLogin', ItxGoogleLoginCmp);

    itxApp.common.ItxGoogleLoginCmp = ItxGoogleLoginCmp;
    itxApp.common.ItxGoogleLoginCmpCtrl = ItxGoogleLoginCmpCtrl;
})(window.itxApp);
/* jshint ignore:end */
